<template>
	<div class="navbar" :style="{paddingTop:barheight, height:navbarheight}">
		<nav-bar
			:title="title"
			:left-text="lefttext"
			:right-text="righttext"
			:left-arrow="arrow"
			@click-left="onClickLeft"
			@click-right="onClickRight">
		<template v-slot:title v-if="$slots.customTitle">
			<slot name="customTitle" />
		</template>
		</nav-bar>
	</div>	
</template>

<script>
	import { NavBar } from 'vant';
	export default {
		name: 'mytop',
		components: {
			NavBar
		},
		props: {
			lefttext: {
				type: String,
				default: '',
			},
			righttext: {
				type: String,
				default: '',
			},
			title: {
				type: String,
				default: '',
			},
			arrow: {
				type: Boolean,
				default: true,
			}
		},
		data() {
			return {
			}
		},
		methods: {
			onClickLeft() {
				if(this.$listeners['leftclick']) {
					this.$emit('leftclick');
				}else {
					this.$router.go(-1);
				}				
			},
			onClickRight() {
				this.$emit('rightclick');
			}
		},
		created() {
			
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss" scoped>
	.navbar {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		right: 0 !important;
		z-index: 1000 !important;
		width: 100% !important;
		background-color:#fff;
		box-shadow: 2px 0 0 #f7f7f7;
		overflow: hidden;
		::v-deep .van-icon-arrow-left,.van-icon-arrow-right {
			color:#333;
			font-size:18px;
		}
		::v-deep .van-icon-arrow-left {
			font-size: 22px;
		}
		::v-deep .van-nav-bar__text {
			font-size: 18px;
			color:#333;
		}
		::v-deep .van-nav-bar__title {
			font-size:18px;
		    max-width: 60%;
		}
	}
</style>
